import app from 'flarum/forum/app';
import Notification from 'flarum/forum/components/Notification';

export default class DiscussionFeaturedNotification extends Notification {
  icon() {
    return app.forum.attribute('tanka-connector.featuredIcon') || 'fas fa-magic';
  }

  href() {
    const notification = this.attrs.notification;

    return app.route.discussion(notification.subject(), notification.content().postNumber);
  }

  content() {
    return app.translator.trans('tanka-connector.forum.notifications.discussion_featured_text', { user: this.attrs.notification.fromUser() });
  }
}
